
<div *ngIf="data != null">
  <div *ngIf="data.ShowDatePeriod" style="width: 75%; padding-bottom: 2rem;">
    <app-date-selector
      [showInterval]="true"
      [showYear]="true"
      [setTabsDateRangeSelectedIndexInput]="selectedDateRangeIndex"
      [selectedDate]="selectedDate"
      (rangeSelectedIndexChanged)="selectedDateRangeIndexChanged($event)"
      (changeDate)="selectedDateChanged($event)">
    </app-date-selector>
  </div>
  <app-dynamic-grouped-layout
    [dynamicLayout]="data.DynamicTableLayoutContent"
    [tileDataSource]="dynamicLayoutDataSource">
  </app-dynamic-grouped-layout>
</div>
